module.exports = __webpack_public_path__ + "img/Flag_of_Mauritania.8380bb40.svg";